module.exports = __webpack_public_path__ + "static/media/nfc.7ac4f121.svg";